export class UserInfo {
  constructor(readonly username: string, readonly token: string | null, readonly refreshToken: string | null = null) {}
}



// WEBPACK FOOTER //
// ./src/contracts/UserInfo.ts